import { creatorbase } from '@round/api';
import styles from './PurchaseOrderBadges.module.css';
import range from 'lodash/range';
import { Popover, Skeleton } from '@round/ui-kit';
import PurchaseOrderBadge from '../PurchaseOrderBadge/PurchaseOrderBadge';
import { Badge } from '@round/whitelabel-ui';
import { Link } from 'react-router-dom';
import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';
import { useState } from 'react';

type Props = {
    purchaseOrders: creatorbase.PurchaseOrder[];
    isLoading?: boolean;
    maxDisplayedCount?: number;
    noDataLabel?: string;
};

const PurchaseOrderBadges = ({ purchaseOrders, isLoading, maxDisplayedCount = 1, noDataLabel }: Props) => {
    const hiddenPurchaseOrdersCount = purchaseOrders.length - maxDisplayedCount;
    const [hiddenPurchaseOrdersCountElement, setHiddenPurchaseOrdersCountElement] = useState<HTMLSpanElement | null>(
        null
    );

    return (
        <div className={styles.container}>
            {isLoading
                ? range(maxDisplayedCount).map((i) => <Skeleton key={i} width="7rem" height="1.3125rem" />)
                : purchaseOrders
                      .slice(0, maxDisplayedCount)
                      .map((purchaseOrder) => (
                          <PurchaseOrderBadge
                              key={purchaseOrder.id}
                              poNumber={purchaseOrder.number ?? purchaseOrder.request_reference ?? '-'}
                              invoiceNumber={purchaseOrder.invoice_number}
                              invoiceStatus={purchaseOrder.invoice_status}
                          />
                      ))}

            {!isLoading && !purchaseOrders.length && noDataLabel && (
                <span className={styles.noPurchaseOrders}>{noDataLabel}</span>
            )}

            {hiddenPurchaseOrdersCount > 0 && (
                <>
                    <div className={styles.hiddenPurchaseOrdersCountWrapper}>
                        <Badge
                            ref={setHiddenPurchaseOrdersCountElement}
                            className={styles.hiddenPurchaseOrdersCount}
                            onClick={(e) => e.stopPropagation()}
                        >
                            +{hiddenPurchaseOrdersCount}
                        </Badge>
                    </div>
                    <Popover
                        anchorElement={hiddenPurchaseOrdersCountElement}
                        showOn="click"
                        overlayClassName={styles.hiddenPurchaseOrdersOverlay}
                        options={{
                            placement: 'bottom-end',
                            modifiers: [{ name: 'offset', options: { offset: [0, 5] } }],
                        }}
                    >
                        <div className={styles.hiddenPurchaseOrders}>
                            {purchaseOrders.slice(maxDisplayedCount).map((po) => {
                                const poNumber = po.number ?? po.request_reference ?? '-';
                                return (
                                    <Link
                                        to={`/${CREATORBASE_ROOT_PATH}/finance/purchase-orders/?search=${poNumber}`}
                                        rel="noopener noreferrer"
                                        key={po.id}
                                        className={styles.purchaseOrderItem}
                                    >
                                        <p className={styles.purchaseOrderItemNumber}>{poNumber}</p>
                                        <p className={styles.purchaseOrderItemInvoiceNumber}>
                                            {po.invoice_number || 'Uninvoiced'}
                                        </p>
                                    </Link>
                                );
                            })}
                        </div>
                    </Popover>
                </>
            )}
        </div>
    );
};

export default PurchaseOrderBadges;
